import React from 'react';

export const EnvironmentContext = React.createContext({});
